import ListingPage from '../../components/ListingPage';
import WebhooksCards from '../../components/Webhooks/WebhooksCards';

const WebhooksPage = () => {
  return (
    <ListingPage
      createRestrictionKey="webhooksCreate"
      entityType="webhook"
      useStats={true}
      filterBy="name"
      Cards={WebhooksCards}
    />
  );
};

export default WebhooksPage;
